<template>
  <div class="questionnaire-paper">
    <page-progress />
    <div class="questionnaire-wrapper">
      <div class="questionnaire-section" v-for="section in questionnaireData">
        <div class="section-title">{{section.questionsType}}</div>
        <div class="section-list">
          <div class="section-item" v-for="(item, index) in section.questionList">
            <div class="question">{{index + 1}}. {{item.question}}</div>
            <div class="anwser-content">
              <!-- 单选题 -->
              <div class="radio-group" v-if="item.questionType == 'radio'">
                <div class="radio-item" :class="{'checked': item.picked[0] == anwser}" @click="radioCheck(item, anwser)" v-for="anwser in item.options">
                  <span class="radio-icon"></span>{{anwser}}
                </div>
              </div>
              <!-- 多选题 -->
              <div class="multiple-group" v-if="item.questionType == 'mulitple'">
                <div class="multiple-item" :class="{'checked': item.picked.indexOf(anwser) != -1}" @click="multipleCheck(item, anwser)" v-for="anwser in item.options">
                  <span class="multiple-icon"><icon icon-class="anwser-checked"></icon></span>{{anwser}}
                </div>
              </div>
              <!-- 填写题 -->
              <div class="questionnaire-text" v-if="item.questionType == 'text'">
                <textarea class="anwser-text" maxlength="100" v-model="item.text" :placeholder="item.placeholder"></textarea>
                <span class="text-limit">{{item.text.length}}/100</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="next-wrapper">
      <button class="next-button" @click="nextStep">下一步</button>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .questionnaire-paper{
    background: #F7F7F7;
    .questionnaire-wrapper{
      padding-bottom: 1px;
      background: #FFF;
    }
    .questionnaire-section{
      border-bottom: 12px solid #F7F7F7;
      padding: 0 10px;
      background: #FFF;
      border-radius: 6px 6px 0 0;
      &:last-child{
        border-bottom: 0;
      }
      .section-title{
        height: 48px;
        border-bottom: 1px solid #EEE;
        display: flex;
        align-items: center;
        font-size: 16px;
        line-height: 16px;
        color: @xile;
        font-weight: bold;
      }
      .section-list{
        padding-top: 16px;
        .section-item{
          padding: 0 6px;
          margin-bottom: 36px;
          .question{
            font-size: 16px;
            line-height: 16px;
            font-weight: bold;
            color: @black;
          }
          .anwser-content{
            margin-top: 16px;
            .radio-group{
              display: flex;
              flex-wrap: wrap;
              align-items: flex-start;
              justify-content: flex-start;
              .radio-item{
                height: 22px;
                margin-right: 32px;
                margin-bottom: 15px;
                font-size: 14px;
                line-height: 14px;
                color: @black;
                font-weight: normal;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                cursor: pointer;
                &.checked{
                  color: @xile;
                  font-weight: bold;
                  .radio-icon{
                    border-color: @xile;
                    &:after{
                      content: '';
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      width: 8px;
                      height: 8px;
                      background: @xile;
                      border-radius: 50%;
                    }
                  }
                }
                .radio-icon{
                  position: relative;
                  width: 12px;
                  height: 12px;
                  border: 1px solid #999;
                  border-radius: 50%;
                  margin-right: 12px;
                }
              }
            }
            .multiple-group{
              display: flex;
              flex-wrap: wrap;
              align-items: flex-start;
              justify-content: flex-start;
              .multiple-item{
                height: 22px;
                margin-right: 32px;
                margin-bottom: 15px;
                font-size: 14px;
                line-height: 14px;
                color: @black;
                font-weight: normal;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                cursor: pointer;
                &.checked{
                  color: @xile;
                  font-weight: bold;
                  .multiple-icon{
                    border-color: @xile;
                    svg{
                      opacity: 1;
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      width: 12px;
                      height: 12px;
                      border-radius: 50%;
                      font-weight: bold;
                    }
                  }
                }
                .multiple-icon{
                  position: relative;
                  width: 12px;
                  height: 12px;
                  border: 1px solid #999;
                  border-radius: 2px;
                  margin-right: 12px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  svg{
                    opacity: 0;
                  }
                }
              }
            }
            .questionnaire-text{
              width: 100%;
              position: relative;
              .anwser-text{
                border: 1px solid #F7F7F7;
                background: #F7F7F7;
                resize: none;
                padding: 12px;
                font-size: 14px;
                line-height: 20px;
                color: #666;
                width: 100%;
                height: 96px;
                &::-webkit-input-placeholder{
                  color: #999;
                }
              }
              .text-limit{
                position: absolute;
                right: 10px;
                bottom: 10px;
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
      }
    }
    .next-wrapper{
      padding: 24px 24px 12px;
      background: #F7F7F7;
      .next-button{
        @button-base();
        width: 100%;
        height: 40px;
      }
    }
  }
</style>

<script type="text/javascript">
  import pageProgress from '@/components/Common/pageScrollProgress'
  import questionnaireData from '@/config/questionnaire'
  export default {
    data() {
      return {
        questionnaireId: this.$route.query.id,
        questionnaireData: JSON.parse(JSON.stringify(questionnaireData.base)),
      }
    },
    created() {
      this.$root.post('/getAnswerDetail', {
        id: this.questionnaireId,
        type: 2
      }).then(data => {
        // 数据回显
        if(data.second && data.second.length > 0) {
          this.questionnaireData.forEach(section => {
            data.second.forEach(dataSection => {
              if(dataSection.questionsType == section.questionsType) {
                section.questionList.forEach(item => {
                  dataSection.questionList.forEach(dataItem => {
                    if(dataItem.question == item.question) {
                      if(dataItem.questionType == 'text') {
                        item.text = dataItem.text;
                      }else {
                        item.picked = dataItem.picked;
                      }
                    }
                  })
                })
              }
            })
          })
        }
        console.log(this.questionnaireData)
      })
    },
    components: {
      pageProgress
    },
    methods: {
      // 单选
      radioCheck(item, anwser) {
        item.picked = [];
        item.picked.push(anwser);
      },
      // 多选
      multipleCheck(item, anwser) {
        let index = item.picked.findIndex(item => {
          return item == anwser;
        })
        if(index != -1) {
          item.picked.splice(index, 1);
        }else {
          item.picked.push(anwser);
        }
      },
      nextStep() {
        let anwserData = [];
        this.questionnaireData.forEach(section => {
          // 获取每个大类下的已选问题
          let sectionData = [];
          section.questionList.forEach(question => {
            if(question.questionType == 'text' && question.text != '') {
              sectionData.push({
                questionType: question.questionType,
                question: question.question,
                text: question.text
              })
            }else if((question.questionType == 'radio' || question.questionType == 'mulitple') && question.picked.length > 0) {
              sectionData.push({
                questionType: question.questionType,
                question: question.question,
                picked: question.picked
              })
            }
          })
          if(sectionData.length > 0) {
            anwserData.push({
              questionsType: section.questionsType,
              questionList: sectionData
            })
          }
        })
        this.$root.post('/addPatientAnswer', {
          id: this.questionnaireId,
          second: anwserData.length > 0 ? anwserData : ''
        }).then(data => {
          console.log(data);
          if(data.status == 1) {
            this.$router.push({path: '/patient/questionnaire/step-three', query: {id: this.questionnaireId}});
          }else {
            this.$notify(data.msg);
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Questionnaire/stepTwo.vue